import { render, staticRenderFns } from "./PengurusKati.vue?vue&type=template&id=dcbf1c18"
import script from "./PengurusKati.vue?vue&type=script&lang=js"
export * from "./PengurusKati.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports